import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class NeonView extends View {
    setup() {
        this.label = "Neon CDC";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.NEON.id);
        this.model.set("isCDC", true);
    }
}

module.View = NeonView;
module.vent = new Backbone.Model();
export default module;
